export default {
  message: {
    hello: 'Halo Dunia'
  }
}